import { Instagram } from "lucide-react";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1-2.59-2.6 2.6 2.6 0 0 1 3.37-2.48V9.66a5.73 5.73 0 0 0-.78-.05A5.69 5.69 0 0 0 4.17 15.3 5.69 5.69 0 0 0 9.86 21a5.69 5.69 0 0 0 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.3 4.3 0 0 1-3.25-1.48Z" />
  </svg>
);

export const SOCIALS = [
  { id: "instagram", label: "@latinakarla_digital", href: "https://www.instagram.com/latinakarla_digital", Icon: Instagram },
  { id: "tiktok", label: "@skylinemounce", href: "https://www.tiktok.com/@skylinemounce", Icon: TikTok },
];

export const SocialLinks = ({ light = false, withLabel = false }) => (
  <div className="flex flex-wrap items-center gap-3">
    {SOCIALS.map(({ id, label, href, Icon }) => (
      <a key={id} href={href} target="_blank" rel="noreferrer" aria-label={`Síguenos en ${id}`} data-testid={`social-${id}-link`}
        className={`inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-medium transition-colors duration-300 ${
          light ? "border-[#FAF7F2]/20 text-[#FAF7F2] hover:bg-[#FAF7F2] hover:text-[#1E1A17]" : "border-[#E8E1D7] text-[#1E1A17] hover:border-[#E05A47] hover:bg-[#E05A47] hover:text-white"
        }`}>
        <Icon className="h-4 w-4" />
        {withLabel && <span>{label}</span>}
      </a>
    ))}
  </div>
);
